import FullWidthLayout from "@/layouts/FullWidthLayout";
import KTripCostEstimator from "kinnect-front/KYard/TripCostEstimator/KTripCostEstimator";
import { Pageable } from "kinnect-mixins";

export default {
	name: "YardTripCostEstimatorPage",

	metaInfo: { title: "Yard - Trip Cost Estimator" },

	mixins: [ Pageable ],

	render() {
		return <FullWidthLayout>
			<KTripCostEstimator></KTripCostEstimator>
		</FullWidthLayout>;
	}
};
